import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { sendOTP, resetPassword } from "../../api/authApi";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [step, setStep] = useState(1);
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleSendOTP = async () => {
    if (!email) return toast.error("Please enter your email.");

    try {
      const res = await sendOTP({ email });

      if (res.data.status) {
        toast.success(res.data.message);
        setStep(2);
      } else {
        toast.error(res.data.message);
      }
    } catch {
      toast.error("Error sending OTP.");
    }
  };

  const handleResetPassword = async () => {
    if (!otp || !password || !confirmPassword)
      return toast.error("All fields are required.");

    if (password.length < 6)
      return toast.error("Password must be at least 6 characters.");

    if (password !== confirmPassword)
      return toast.error("Passwords do not match.");

    try {
      const res = await resetPassword({
        email,
        otp,
        password,
        confirmPassword,
      });

      if (res.data.status) {
        toast.success("Password reset successful!");
        setTimeout(() => navigate("/login"), 1000);
      } else {
        toast.error(res.data.message);
      }
    } catch {
      toast.error("Something went wrong.");
    }
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center py-5"
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg,#2563eb 0%, #4f46e5 50%, #7c3aed 100%)",
      }}
    >
      <div className="container">
        <div className="row justify-content-center align-items-center">
          {/* Left Side */}
          <div className="col-lg-6 d-none d-lg-block text-white">
            <h1
              className="fw-bold mb-4"
              style={{ fontSize: "52px", lineHeight: 1.2 }}
            >
              Reset Your Password 🔐
            </h1>

            <p className="fs-5 opacity-75">
              Verify your email with OTP and securely create a new password to
              regain access to your account.
            </p>

            <div className="mt-5">
              <div className="d-flex align-items-center mb-4">
                <i className="fa-solid fa-envelope fs-3 me-3"></i>
                Email Verification
              </div>

              <div className="d-flex align-items-center mb-4">
                <i className="fa-solid fa-key fs-3 me-3"></i>
                OTP Authentication
              </div>

              <div className="d-flex align-items-center">
                <i className="fa-solid fa-shield-halved fs-3 me-3"></i>
                100% Secure Process
              </div>
            </div>
          </div>

          {/* Card */}
          <div className="col-lg-5 col-md-8">
            <div
              className="shadow-lg"
              style={{
                background: "rgba(255,255,255,0.97)",
                borderRadius: "30px",
                padding: "45px",
              }}
            >
              <div className="text-center mb-4">
                <div
                  style={{
                    width: 80,
                    height: 80,
                    borderRadius: "50%",
                    background:
                      "linear-gradient(135deg,#2563eb,#7c3aed)",
                    margin: "0 auto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <i
                    className="fa-solid fa-unlock-keyhole"
                    style={{
                      color: "#fff",
                      fontSize: 30,
                    }}
                  ></i>
                </div>

                <h2 className="fw-bold mt-3">
                  {step === 1 ? "Forgot Password" : "Verify OTP"}
                </h2>

                <p className="text-muted">
                  {step === 1
                    ? "Enter your registered email"
                    : "Enter OTP and create a new password"}
                </p>
              </div>

              {step === 1 ? (
                <>
                  <div className="position-relative mb-4">
                    <i
                      className="fa-solid fa-envelope position-absolute"
                      style={{
                        left: 18,
                        top: 18,
                        color: "#94a3b8",
                      }}
                    ></i>

                    <input
                      type="email"
                      className="form-control ps-5"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      style={{
                        height: 55,
                        borderRadius: 50,
                      }}
                    />
                  </div>

                  <button
                    onClick={handleSendOTP}
                    className="btn w-100 text-white fw-bold"
                    style={{
                      height: 55,
                      borderRadius: 50,
                      background:
                        "linear-gradient(135deg,#2563eb,#4f46e5,#7c3aed)",
                      border: "none",
                    }}
                  >
                    Send OTP →
                  </button>

                  <div className="text-center mt-4">
                    <Link
                      to="/login"
                      className="text-decoration-none fw-semibold"
                    >
                      ← Back to Login
                    </Link>
                  </div>
                </>
              ) : (
                <>
                  <input
                    className="form-control mb-3"
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    style={{
                      height: 55,
                      borderRadius: 50,
                    }}
                  />

                  <div className="position-relative mb-3">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control pe-5"
                      placeholder="New Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      style={{
                        height: 55,
                        borderRadius: 50,
                      }}
                    />

                    <i
                      className={`fa-solid ${
                        showPassword ? "fa-eye-slash" : "fa-eye"
                      } position-absolute`}
                      style={{
                        right: 20,
                        top: 19,
                        cursor: "pointer",
                        color: "#64748b",
                      }}
                      onClick={() => setShowPassword(!showPassword)}
                    ></i>
                  </div>

                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control mb-4"
                    placeholder="Confirm Password"
                    value={confirmPassword}
                    onChange={(e) =>
                      setConfirmPassword(e.target.value)
                    }
                    style={{
                      height: 55,
                      borderRadius: 50,
                    }}
                  />

                  <button
                    onClick={handleResetPassword}
                    className="btn w-100 text-white fw-bold"
                    style={{
                      height: 55,
                      borderRadius: 50,
                      background:
                        "linear-gradient(135deg,#16a34a,#22c55e)",
                      border: "none",
                    }}
                  >
                    Reset Password ✓
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}